import React from "react";
import "./DataAndResearchReportCss.css"


const DataAndResearchData = () => {
    return (
        <div id="projects" className="p-5 " style={{backgroundColor:"#F5EEE6"}}>
            <div className="logo-container w-container">

                <div className="container ">
                    <div className="row ">
                        <div className="col-md-8 col-sm-6 col-12">
                            <h2 className="font-style">Data and Research Reports</h2>
                            <p
                            className="mb-5">‘Research and data’, must not be misunderstood. In the context
                            of Gammadda, it means that the combined teams made up of Gammadda volunteers from News 1st
                            and undergraduates of The University of Peradeniya, spend months walking from home to home
                            across rural Sri Lanka, listening to people and collating information. Sri Lanka has
                            thousands of villages, and we have adopted a slow and concerted approach to reach them all.
                            One step at a time. One year at a time.</p><a
                            href="https://cdn.prod.website-files.com/5f6f242444d996479a66a50c/62f7a5eeb83f2dd5006f0971_Gammadda%20Door%20to%20door%20Report%202020%20Final_WithoutHistry-compressed%20(2).pdf"
                            target="_blank" className="button">Read our research</a></div>
                        <div className=" mt-5 col-md-4 col-sm-6 col-12"><img className="image-report"
                            src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ab1_Gammadda-Door-to-Door-Edition-4-ow3e6jy3vkuiv26zlh4c335cd73semm91dikxso3bq.jpeg"
                            alt="Gammadda Door to door"/></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DataAndResearchData